<template>
    <div class="about-view">
        <About />
    </div>
</template>

<script src="./AboutView.js"></script>
<style lang="scss" scoped src="./AboutView.scss" />
